import { MatterPersonnelEditorContent } from "./MatterPersonnelEditorContent";
import type { Matter } from "@/lib/types";

export function MatterPersonnelEditor({
  matter,
  open,
  onOpenChange,
}: {
  matter: Matter;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return open ? (
    <MatterPersonnelEditorContent
      matter={matter}
      close={() => {
        onOpenChange(false);
      }}
    />
  ) : null;
}
